import ChatMessageDetailReaction from '@/screens/ChatMessageDetailReaction';

export default function PrivateChatChatIdMessageMessageIdReactionsIndexRoute() {
  return <ChatMessageDetailReaction />;
}
